import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { useAdminCardDecksVariants } from '@olagg/api-hooks';
import VariantForm from './Form';
import { CreateCardDeckVariantData } from '@olagg/db-types';
import { Center, VStack, Heading } from '@chakra-ui/react';

export const CreateVariant = () => {
  const navigate = useNavigate();
  const { deck_id, trait_id } = useParams();

  if (!deck_id || !trait_id) return null;
  
  const { createVariant } = useAdminCardDecksVariants(deck_id, trait_id);

  const handleSubmit = async (data: CreateCardDeckVariantData) => {
    await createVariant(data);
    navigate(generatePath(ROUTES.CARD_DECKS.variants.all, { deck_id, trait_id }));
  };

  return (
    <Center w={'full'} pb={4}>
      <VStack color={'white'} w={'full'}>
        <Heading my={2}>
          Crear Variante
        </Heading>
        <VariantForm onSubmit={handleSubmit} />
      </VStack>
    </Center>
  );
};
